<template>
  <section :class="isprint==1?'loadingBtn':'loadingWrap'">
    <div class="loadingBox">
      <span class="girl"></span>
      <div class="boys">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageLoading',
  props:{
    isprint:{
      type:Number,
      default:0,//0:默认  1：勿动遮罩
    },
  },
  data() {
    return {

    }
  },
  methods: {

  },
}
</script>

<style scoped>
.loadingWrap {position:fixed; top:50px;left:174px; z-index:3; width:calc(100vw - 174px); height:calc(100vh - 50px); background:rgba(255,255,255,.8); align-items: center;}
.loadingBtn {position:relative;width:100%;height: 100px; display: flex; align-items: center; justify-content: center;}
.helpRight .loadingWrap{left:174px;width:calc(100vw - 174px);}
.outHelp .loadingWrap{left:174px;width:calc(100vw - 394px);}
.takeLeft.helpRight .loadingWrap{left:0;width:100vw;}
.takeLeft.outHelp .loadingWrap{left:0;width:calc(100vw - 220px);}

.loadingBox{position:absolute; left:50%; top:50%; margin-left:-4em; margin-top:-.5em; width:8em;height:1em;font-size:35px;display:flex;justify-content:space-between;}
.loadingBox span{width:1em;height:1em;--duration:1.5s}
.girl{animation:slide var(--duration) ease-in-out infinite alternate}
@keyframes slide{
  from{transform:translateX(0);filter:brightness(1)}
  to{transform:translatex(calc(8em - (1em * 1.25)));filter:brightness(1.45)}
}
.boys{width:6em;display:flex;justify-content:space-between}
.boys span{animation:var(--duration) ease-in-out infinite alternate}
.boys span:nth-child(1){animation-name:jump-off-1}
.boys span:nth-child(2){animation-name:jump-off-2}
.boys span:nth-child(3){animation-name:jump-off-3}
.boys span:nth-child(4){animation-name:jump-off-4}
@keyframes jump-off-1{0%,15%{transform:rotate(0)}
100%,35%{transform-origin:-50% center;transform:rotate(-180deg)}
}
@keyframes jump-off-2{0%,30%{transform:rotate(0)}
100%,50%{transform-origin:-50% center;transform:rotate(-180deg)}
}
@keyframes jump-off-3{0%,45%{transform:rotate(0)}
100%,65%{transform-origin:-50% center;transform:rotate(-180deg)}
}
@keyframes jump-off-4{0%,60%{transform:rotate(0)}
100%,80%{transform-origin:-50% center;transform:rotate(-180deg)}
}
.loadingBox span::before{content:'';position:absolute;width:inherit;height:inherit;border-radius:15%;box-shadow:0 0 .1em rgba(0,0,0,.3)}
.girl::before{background-color:#ff69b4}
.boys span::before{background-color:#1e90ff;animation:var(--duration) ease-in-out infinite alternate}
.boys span:nth-child(1)::before{filter:brightness(1);animation-name:jump-down-1}
.boys span:nth-child(2)::before{filter:brightness(1.15);animation-name:jump-down-2}
.boys span:nth-child(3)::before{filter:brightness(1.3);animation-name:jump-down-3}
.boys span:nth-child(4)::before{filter:brightness(1.45);animation-name:jump-down-4}
@keyframes jump-down-1{5%{transform:scale(1,1)}
15%{transform-origin:center bottom;transform:scale(1.3,.7)}
20%,25%{transform-origin:center bottom;transform:scale(.8,1.4)}
40%{transform-origin:center top;transform:scale(1.3,.7)}
100%,55%{transform:scale(1,1)}
}
@keyframes jump-down-2{20%{transform:scale(1,1)}
30%{transform-origin:center bottom;transform:scale(1.3,.7)}
35%,40%{transform-origin:center bottom;transform:scale(.8,1.4)}
55%{transform-origin:center top;transform:scale(1.3,.7)}
100%,70%{transform:scale(1,1)}
}
@keyframes jump-down-3{35%{transform:scale(1,1)}
45%{transform-origin:center bottom;transform:scale(1.3,.7)}
50%,55%{transform-origin:center bottom;transform:scale(.8,1.4)}
70%{transform-origin:center top;transform:scale(1.3,.7)}
100%,85%{transform:scale(1,1)}
}
@keyframes jump-down-4{50%{transform:scale(1,1)}
60%{transform-origin:center bottom;transform:scale(1.3,.7)}
65%,70%{transform-origin:center bottom;transform:scale(.8,1.4)}
85%{transform-origin:center top;transform:scale(1.3,.7)}
100%{transform:scale(1,1)}
}

.tipDescription p {font-size: 28px; color:#666; line-height:70px;}
</style>



// WEBPACK FOOTER //
// src/components/common/PageLoading.vue